import type { CountryCode } from 'libphonenumber-js'

export interface CountryData {
  label: string
  /** ISO-3166-1 alpha-2 region code (e.g. 'US', 'GB', 'IE') — used as the default region when
   * normalizing phone numbers to E.164. See getRegionCode / normalizePhoneToE164. */
  iso: string
  currency: { name: string; symbol: string }
}

export const countries: CountryData[] = [
  { label: 'United States', iso: 'US', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Canada', iso: 'CA', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Australia', iso: 'AU', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'New Zealand', iso: 'NZ', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'United Kingdom', iso: 'GB', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Afghanistan', iso: 'AF', currency: { name: 'Afghani', symbol: '؋' } },
  { label: 'Åland Islands', iso: 'AX', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Albania', iso: 'AL', currency: { name: 'Lek', symbol: 'L' } },
  { label: 'Algeria', iso: 'DZ', currency: { name: 'Dinar', symbol: 'دج' } },
  { label: 'American Samoa', iso: 'AS', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Andorra', iso: 'AD', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Angola', iso: 'AO', currency: { name: 'Kwanza', symbol: 'Kz' } },
  { label: 'Anguilla', iso: 'AI', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Antigua and Barbuda', iso: 'AG', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Argentina', iso: 'AR', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Armenia', iso: 'AM', currency: { name: 'Dram', symbol: '֏' } },
  { label: 'Aruba', iso: 'AW', currency: { name: 'Florin', symbol: 'ƒ' } },
  { label: 'Austria', iso: 'AT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Azerbaijan', iso: 'AZ', currency: { name: 'Manat', symbol: '₼' } },
  { label: 'Bahamas', iso: 'BS', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bahrain', iso: 'BH', currency: { name: 'Dinar', symbol: 'BD' } },
  { label: 'Bangladesh', iso: 'BD', currency: { name: 'Taka', symbol: '৳' } },
  { label: 'Barbados', iso: 'BB', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Belarus', iso: 'BY', currency: { name: 'Ruble', symbol: 'Br' } },
  { label: 'Belgium', iso: 'BE', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Belize', iso: 'BZ', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Benin', iso: 'BJ', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Bermuda', iso: 'BM', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bhutan', iso: 'BT', currency: { name: 'Ngultrum', symbol: 'Nu' } },
  { label: 'Bolivia', iso: 'BO', currency: { name: 'Boliviano', symbol: 'Bs' } },
  { label: 'Bosnia and Herzegovina', iso: 'BA', currency: { name: 'Marka', symbol: 'KM' } },
  { label: 'Botswana', iso: 'BW', currency: { name: 'Pula', symbol: 'P' } },
  { label: 'Brazil', iso: 'BR', currency: { name: 'Real', symbol: 'R$' } },
  { label: 'Brunei Darussalam', iso: 'BN', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bulgaria', iso: 'BG', currency: { name: 'Lev', symbol: 'лв' } },
  { label: 'Burkina Faso', iso: 'BF', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Burundi', iso: 'BI', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Cambodia', iso: 'KH', currency: { name: 'Riel', symbol: '៛' } },
  { label: 'Cameroon', iso: 'CM', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Cape Verde', iso: 'CV', currency: { name: 'Escudo', symbol: '$' } },
  { label: 'Cayman Islands', iso: 'KY', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Central African Republic', iso: 'CF', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Chad', iso: 'TD', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Chile', iso: 'CL', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'China', iso: 'CN', currency: { name: 'Yuan', symbol: '¥' } },
  { label: 'Colombia', iso: 'CO', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Comoros', iso: 'KM', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Congo', iso: 'CG', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Congo, The Democratic Republic of the', iso: 'CD', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Cook Islands', iso: 'CK', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Costa Rica', iso: 'CR', currency: { name: 'Colón', symbol: '₡' } },
  { label: "Cote D'Ivoire", iso: 'CI', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Croatia', iso: 'HR', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Cuba', iso: 'CU', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Cyprus', iso: 'CY', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Czech Republic', iso: 'CZ', currency: { name: 'Koruna', symbol: 'Kč' } },
  { label: 'Denmark', iso: 'DK', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Djibouti', iso: 'DJ', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Dominica', iso: 'DM', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Dominican Republic', iso: 'DO', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Ecuador', iso: 'EC', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Egypt', iso: 'EG', currency: { name: 'Pound', symbol: '£' } },
  { label: 'El Salvador', iso: 'SV', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Equatorial Guinea', iso: 'GQ', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Eritrea', iso: 'ER', currency: { name: 'Nakfa', symbol: 'Nfk' } },
  { label: 'Estonia', iso: 'EE', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Ethiopia', iso: 'ET', currency: { name: 'Birr', symbol: 'Br' } },
  { label: 'Falkland Islands (Malvinas)', iso: 'FK', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Faroe Islands', iso: 'FO', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Fiji', iso: 'FJ', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Finland', iso: 'FI', currency: { name: 'Euro', symbol: '€' } },
  { label: 'France', iso: 'FR', currency: { name: 'Euro', symbol: '€' } },
  { label: 'French Guiana', iso: 'GF', currency: { name: 'Euro', symbol: '€' } },
  { label: 'French Polynesia', iso: 'PF', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Gabon', iso: 'GA', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Gambia', iso: 'GM', currency: { name: 'Dalasi', symbol: 'D' } },
  { label: 'Georgia', iso: 'GE', currency: { name: 'Lari', symbol: '₾' } },
  { label: 'Germany', iso: 'DE', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Ghana', iso: 'GH', currency: { name: 'Cedi', symbol: '₵' } },
  { label: 'Gibraltar', iso: 'GI', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Greece', iso: 'GR', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Greenland', iso: 'GL', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Grenada', iso: 'GD', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Guadeloupe', iso: 'GP', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Guam', iso: 'GU', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Guatemala', iso: 'GT', currency: { name: 'Quetzal', symbol: 'Q' } },
  { label: 'Guernsey', iso: 'GG', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Guinea', iso: 'GN', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Guinea-Bissau', iso: 'GW', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Guyana', iso: 'GY', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Haiti', iso: 'HT', currency: { name: 'Gourde', symbol: 'G' } },
  { label: 'Vatican City', iso: 'VA', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Honduras', iso: 'HN', currency: { name: 'Lempira', symbol: 'L' } },
  { label: 'Hong Kong', iso: 'HK', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Hungary', iso: 'HU', currency: { name: 'Forint', symbol: 'Ft' } },
  { label: 'Iceland', iso: 'IS', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'India', iso: 'IN', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Indonesia', iso: 'ID', currency: { name: 'Rupiah', symbol: 'Rp' } },
  { label: 'Iran', iso: 'IR', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Iraq', iso: 'IQ', currency: { name: 'Dinar', symbol: 'ع.د' } },
  { label: 'Ireland', iso: 'IE', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Isle of Man', iso: 'IM', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Israel', iso: 'IL', currency: { name: 'Shekel', symbol: '₪' } },
  { label: 'Italy', iso: 'IT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Jamaica', iso: 'JM', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Japan', iso: 'JP', currency: { name: 'Yen', symbol: '¥' } },
  { label: 'Jersey', iso: 'JE', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Jordan', iso: 'JO', currency: { name: 'Dinar', symbol: 'JD' } },
  { label: 'Kazakhstan', iso: 'KZ', currency: { name: 'Tenge', symbol: '₸' } },
  { label: 'Kenya', iso: 'KE', currency: { name: 'Shilling', symbol: 'KSh' } },
  { label: 'Kiribati', iso: 'KI', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'North Korea', iso: 'KP', currency: { name: 'Won', symbol: '₩' } },
  { label: 'South Korea', iso: 'KR', currency: { name: 'Won', symbol: '₩' } },
  { label: 'Kuwait', iso: 'KW', currency: { name: 'Dinar', symbol: 'KD' } },
  { label: 'Kyrgyzstan', iso: 'KG', currency: { name: 'Som', symbol: 'с' } },
  { label: 'Laos', iso: 'LA', currency: { name: 'Kip', symbol: '₭' } },
  { label: 'Latvia', iso: 'LV', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Lebanon', iso: 'LB', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Lesotho', iso: 'LS', currency: { name: 'Loti', symbol: 'L' } },
  { label: 'Liberia', iso: 'LR', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Libya', iso: 'LY', currency: { name: 'Dinar', symbol: 'LD' } },
  { label: 'Liechtenstein', iso: 'LI', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Lithuania', iso: 'LT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Luxembourg', iso: 'LU', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Macao', iso: 'MO', currency: { name: 'Pataca', symbol: 'P' } },
  { label: 'North Macedonia', iso: 'MK', currency: { name: 'Denar', symbol: 'ден' } },
  { label: 'Madagascar', iso: 'MG', currency: { name: 'Ariary', symbol: 'Ar' } },
  { label: 'Malawi', iso: 'MW', currency: { name: 'Kwacha', symbol: 'MK' } },
  { label: 'Malaysia', iso: 'MY', currency: { name: 'Ringgit', symbol: 'RM' } },
  { label: 'Maldives', iso: 'MV', currency: { name: 'Rufiyaa', symbol: 'Rf' } },
  { label: 'Mali', iso: 'ML', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Malta', iso: 'MT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Marshall Islands', iso: 'MH', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Martinique', iso: 'MQ', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mauritania', iso: 'MR', currency: { name: 'Ouguiya', symbol: 'UM' } },
  { label: 'Mauritius', iso: 'MU', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Mayotte', iso: 'YT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mexico', iso: 'MX', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Moldova', iso: 'MD', currency: { name: 'Leu', symbol: 'L' } },
  { label: 'Monaco', iso: 'MC', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mongolia', iso: 'MN', currency: { name: 'Tögrög', symbol: '₮' } },
  { label: 'Montserrat', iso: 'MS', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Morocco', iso: 'MA', currency: { name: 'Dirham', symbol: 'MAD' } },
  { label: 'Mozambique', iso: 'MZ', currency: { name: 'Metical', symbol: 'MT' } },
  { label: 'Myanmar', iso: 'MM', currency: { name: 'Kyat', symbol: 'K' } },
  { label: 'Namibia', iso: 'NA', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Nauru', iso: 'NR', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Nepal', iso: 'NP', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Netherlands', iso: 'NL', currency: { name: 'Euro', symbol: '€' } },
  { label: 'New Caledonia', iso: 'NC', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Nicaragua', iso: 'NI', currency: { name: 'Córdoba', symbol: 'C$' } },
  { label: 'Niger', iso: 'NE', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Nigeria', iso: 'NG', currency: { name: 'Naira', symbol: '₦' } },
  { label: 'Northern Mariana Islands', iso: 'MP', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Norway', iso: 'NO', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Oman', iso: 'OM', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Pakistan', iso: 'PK', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Palau', iso: 'PW', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Palestine', iso: 'PS', currency: { name: 'Shekel', symbol: '₪' } },
  { label: 'Panama', iso: 'PA', currency: { name: 'Balboa', symbol: 'B/.' } },
  { label: 'Papua New Guinea', iso: 'PG', currency: { name: 'Kina', symbol: 'K' } },
  { label: 'Paraguay', iso: 'PY', currency: { name: 'Guaraní', symbol: '₲' } },
  { label: 'Peru', iso: 'PE', currency: { name: 'Sol', symbol: 'S/' } },
  { label: 'Philippines', iso: 'PH', currency: { name: 'Philippine Peso', symbol: '₱' } },
  { label: 'Poland', iso: 'PL', currency: { name: 'Złoty', symbol: 'zł' } },
  { label: 'Portugal', iso: 'PT', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Puerto Rico', iso: 'PR', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Qatar', iso: 'QA', currency: { name: 'Riyal', symbol: 'ر.ق' } },
  { label: 'Romania', iso: 'RO', currency: { name: 'Leu', symbol: 'lei' } },
  { label: 'Russia', iso: 'RU', currency: { name: 'Ruble', symbol: '₽' } },
  { label: 'Rwanda', iso: 'RW', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Saint Helena', iso: 'SH', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Saint Kitts and Nevis', iso: 'KN', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Saint Lucia', iso: 'LC', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Saint Pierre and Miquelon', iso: 'PM', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Saint Vincent and the Grenadines', iso: 'VC', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Samoa', iso: 'WS', currency: { name: 'Tālā', symbol: 'T' } },
  { label: 'San Marino', iso: 'SM', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Sao Tome and Principe', iso: 'ST', currency: { name: 'Dobra', symbol: 'Db' } },
  { label: 'Saudi Arabia', iso: 'SA', currency: { name: 'Riyal', symbol: 'ر.س' } },
  { label: 'Senegal', iso: 'SN', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Montenegro', iso: 'ME', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Serbia', iso: 'RS', currency: { name: 'Dinar', symbol: 'din' } },
  { label: 'Seychelles', iso: 'SC', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Sierra Leone', iso: 'SL', currency: { name: 'Leone', symbol: 'Le' } },
  { label: 'Singapore', iso: 'SG', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Slovakia', iso: 'SK', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Slovenia', iso: 'SI', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Solomon Islands', iso: 'SB', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Somalia', iso: 'SO', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'South Africa', iso: 'ZA', currency: { name: 'Rand', symbol: 'R' } },
  { label: 'Spain', iso: 'ES', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Sri Lanka', iso: 'LK', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Sudan', iso: 'SD', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Suriname', iso: 'SR', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Eswatini', iso: 'SZ', currency: { name: 'Lilangeni', symbol: 'L' } },
  { label: 'Sweden', iso: 'SE', currency: { name: 'Krona', symbol: 'kr' } },
  { label: 'Switzerland', iso: 'CH', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Syria', iso: 'SY', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Taiwan', iso: 'TW', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Tajikistan', iso: 'TJ', currency: { name: 'Somoni', symbol: 'SM' } },
  { label: 'Tanzania', iso: 'TZ', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'Thailand', iso: 'TH', currency: { name: 'Baht', symbol: '฿' } },
  { label: 'Timor-Leste', iso: 'TL', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Togo', iso: 'TG', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Tonga', iso: 'TO', currency: { name: "Pa'anga", symbol: 'T$' } },
  { label: 'Trinidad and Tobago', iso: 'TT', currency: { name: 'Trinidad and Tobago Dollar', symbol: 'TT$' } },
  { label: 'Tunisia', iso: 'TN', currency: { name: 'Dinar', symbol: 'DT' } },
  { label: 'Turkey', iso: 'TR', currency: { name: 'Lira', symbol: '₺' } },
  { label: 'Turkmenistan', iso: 'TM', currency: { name: 'Manat', symbol: 'T' } },
  { label: 'Turks and Caicos Islands', iso: 'TC', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Tuvalu', iso: 'TV', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Uganda', iso: 'UG', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'Ukraine', iso: 'UA', currency: { name: 'Hryvnia', symbol: '₴' } },
  { label: 'United Arab Emirates', iso: 'AE', currency: { name: 'Dirham', symbol: 'د.إ' } },
  { label: 'Uruguay', iso: 'UY', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Uzbekistan', iso: 'UZ', currency: { name: 'Som', symbol: 'с' } },
  { label: 'Vanuatu', iso: 'VU', currency: { name: 'Vatu', symbol: 'Vt' } },
  { label: 'Venezuela', iso: 'VE', currency: { name: 'Bolívar', symbol: 'Bs.S' } },
  { label: 'Vietnam', iso: 'VN', currency: { name: 'Dong', symbol: '₫' } },
  { label: 'Virgin Islands, British', iso: 'VG', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Virgin Islands, U.S.', iso: 'VI', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Wallis and Futuna', iso: 'WF', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Western Sahara', iso: 'EH', currency: { name: 'Dirham', symbol: 'MAD' } },
  { label: 'Yemen', iso: 'YE', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Zambia', iso: 'ZM', currency: { name: 'Kwacha', symbol: 'ZK' } },
  { label: 'Zimbabwe', iso: 'ZW', currency: { name: 'Dollar', symbol: '$' } }
]

export const COUNTRY_OPTIONS: { label: string; value: string }[] = countries.map(({ label }) => ({
  label,
  value: label
}))

export const COUNTRY_CURRENCY_MAP: Record<string, { name: string; symbol: string }> = Object.fromEntries(
  countries.map((c) => [c.label, c.currency])
)

/** Maps a country's full-name label (the value stored in `companyCountry`) to its ISO-3166-1
 * alpha-2 region code. */
export const COUNTRY_ISO_MAP: Record<string, string> = Object.fromEntries(countries.map((c) => [c.label, c.iso]))

/**
 * Resolve a `companyCountry` full-name value (e.g. 'United States', 'Ireland') to its ISO-3166-1
 * alpha-2 region code (e.g. 'US', 'IE'), suitable as the default region for phone-number parsing.
 * Returns undefined for empty, non-string, or unrecognized values. Accepts the broad
 * `OptionsDocument` value type (string | number | boolean) so callers can pass it directly.
 */
export function getRegionCode(countryName?: string | number | boolean | null): CountryCode | undefined {
  if (typeof countryName !== 'string' || !countryName) {
    return undefined
  }
  return COUNTRY_ISO_MAP[countryName] as CountryCode | undefined
}

const _currencyFirstOccurrenceIndex = new Map<string, number>()
countries.forEach((c, i) => {
  if (!_currencyFirstOccurrenceIndex.has(c.currency.name)) {
    _currencyFirstOccurrenceIndex.set(c.currency.name, i)
  }
})

export const CURRENCY_OPTIONS: { label: string; value: string }[] = Array.from(
  new Map(countries.map((c) => [c.currency.name, c.currency])).values()
)
  .sort((a, b) => {
    const aIdx = _currencyFirstOccurrenceIndex.get(a.name) ?? Infinity
    const bIdx = _currencyFirstOccurrenceIndex.get(b.name) ?? Infinity
    const FEATURED_CUTOFF = 5
    const aFeatured = aIdx < FEATURED_CUTOFF
    const bFeatured = bIdx < FEATURED_CUTOFF
    if (aFeatured && bFeatured) return aIdx - bIdx
    if (aFeatured) return -1
    if (bFeatured) return 1
    return a.name.localeCompare(b.name)
  })
  .map(({ name, symbol }) => ({ label: `${name} (${symbol})`, value: name }))

/**
 * Full ISO 639-1 language list for profile language preference collection.
 * Intentionally broader than SUPPORTED_LANGS (@paintscout/ui) — painters can
 * save any language code here for analytics and future WO translation support.
 * The UI itself only translates en/es/fr; unsupported codes fall back to 'en'
 * at render time (see AuthorizeUser.getPainterLang).
 */
export const LANGUAGE_OPTIONS: { label: string; value: string }[] = [
  { label: 'Abkhaz', value: 'ab' },
  { label: 'Afar', value: 'aa' },
  { label: 'Afrikaans', value: 'af' },
  { label: 'Akan', value: 'ak' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Amharic', value: 'am' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Aragonese', value: 'an' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Assamese', value: 'as' },
  { label: 'Avaric', value: 'av' },
  { label: 'Avestan', value: 'ae' },
  { label: 'Aymara', value: 'ay' },
  { label: 'Azerbaijani', value: 'az' },
  { label: 'Bambara', value: 'bm' },
  { label: 'Bashkir', value: 'ba' },
  { label: 'Basque', value: 'eu' },
  { label: 'Belarusian', value: 'be' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bihari', value: 'bh' },
  { label: 'Bislama', value: 'bi' },
  { label: 'Bosnian', value: 'bs' },
  { label: 'Breton', value: 'br' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Burmese', value: 'my' },
  { label: 'Catalan', value: 'ca' },
  { label: 'Cebuano', value: 'ceb' },
  { label: 'Chamorro', value: 'ch' },
  { label: 'Chechen', value: 'ce' },
  { label: 'Chichewa', value: 'ny' },
  { label: 'Chinese (Simplified)', value: 'zh' },
  { label: 'Chinese (Traditional)', value: 'zh-TW' },
  { label: 'Chuvash', value: 'cv' },
  { label: 'Cornish', value: 'kw' },
  { label: 'Corsican', value: 'co' },
  { label: 'Cree', value: 'cr' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Divehi', value: 'dv' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Dzongkha', value: 'dz' },
  { label: 'English', value: 'en' },
  { label: 'Esperanto', value: 'eo' },
  { label: 'Estonian', value: 'et' },
  { label: 'Ewe', value: 'ee' },
  { label: 'Faroese', value: 'fo' },
  { label: 'Fijian', value: 'fj' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'Fula', value: 'ff' },
  { label: 'Galician', value: 'gl' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Guaraní', value: 'gn' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haitian Creole', value: 'ht' },
  { label: 'Hausa', value: 'ha' },
  { label: 'Hawaiian', value: 'haw' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Herero', value: 'hz' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hiri Motu', value: 'ho' },
  { label: 'Hmong', value: 'hmn' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Interlingua', value: 'ia' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Interlingue', value: 'ie' },
  { label: 'Irish', value: 'ga' },
  { label: 'Igbo', value: 'ig' },
  { label: 'Inupiaq', value: 'ik' },
  { label: 'Ido', value: 'io' },
  { label: 'Icelandic', value: 'is' },
  { label: 'Italian', value: 'it' },
  { label: 'Inuktitut', value: 'iu' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Javanese', value: 'jv' },
  { label: 'Kalaallisut', value: 'kl' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Kanuri', value: 'kr' },
  { label: 'Kashmiri', value: 'ks' },
  { label: 'Kazakh', value: 'kk' },
  { label: 'Khmer', value: 'km' },
  { label: 'Kikuyu', value: 'ki' },
  { label: 'Kinyarwanda', value: 'rw' },
  { label: 'Kirghiz', value: 'ky' },
  { label: 'Komi', value: 'kv' },
  { label: 'Kongo', value: 'kg' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kurdish', value: 'ku' },
  { label: 'Kwanyama', value: 'kj' },
  { label: 'Lao', value: 'lo' },
  { label: 'Latin', value: 'la' },
  { label: 'Latvian', value: 'lv' },
  { label: 'Limburgish', value: 'li' },
  { label: 'Lingala', value: 'ln' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Luba-Katanga', value: 'lu' },
  { label: 'Luxembourgish', value: 'lb' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malagasy', value: 'mg' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Maltese', value: 'mt' },
  { label: 'Manx', value: 'gv' },
  { label: 'Māori', value: 'mi' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Marshallese', value: 'mh' },
  { label: 'Mongolian', value: 'mn' },
  { label: 'Nauru', value: 'na' },
  { label: 'Navajo', value: 'nv' },
  { label: 'Norwegian Bokmål', value: 'nb' },
  { label: 'North Ndebele', value: 'nd' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Ndonga', value: 'ng' },
  { label: 'Norwegian Nynorsk', value: 'nn' },
  { label: 'Norwegian', value: 'no' },
  { label: 'Nuosu', value: 'ii' },
  { label: 'South Ndebele', value: 'nr' },
  { label: 'Occitan', value: 'oc' },
  { label: 'Ojibwe', value: 'oj' },
  { label: 'Old Church Slavonic', value: 'cu' },
  { label: 'Oromo', value: 'om' },
  { label: 'Oriya', value: 'or' },
  { label: 'Ossetian', value: 'os' },
  { label: 'Panjabi', value: 'pa' },
  { label: 'Pāli', value: 'pi' },
  { label: 'Pashto', value: 'ps' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Quechua', value: 'qu' },
  { label: 'Romansh', value: 'rm' },
  { label: 'Kirundi', value: 'rn' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Sanskrit', value: 'sa' },
  { label: 'Sardinian', value: 'sc' },
  { label: 'Sindhi', value: 'sd' },
  { label: 'Northern Sami', value: 'se' },
  { label: 'Samoan', value: 'sm' },
  { label: 'Sango', value: 'sg' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Scots Gaelic', value: 'gd' },
  { label: 'Shona', value: 'sn' },
  { label: 'Sinhala', value: 'si' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Somali', value: 'so' },
  { label: 'Southern Sotho', value: 'st' },
  { label: 'Spanish', value: 'es' },
  { label: 'Sundanese', value: 'su' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Swati', value: 'ss' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Telugu', value: 'te' },
  { label: 'Tajik', value: 'tg' },
  { label: 'Thai', value: 'th' },
  { label: 'Tigrinya', value: 'ti' },
  { label: 'Tibetan', value: 'bo' },
  { label: 'Turkmen', value: 'tk' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Tswana', value: 'tn' },
  { label: 'Tonga', value: 'to' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Tsonga', value: 'ts' },
  { label: 'Tatar', value: 'tt' },
  { label: 'Twi', value: 'tw' },
  { label: 'Tahitian', value: 'ty' },
  { label: 'Uyghur', value: 'ug' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Venda', value: 've' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Volapük', value: 'vo' },
  { label: 'Walloon', value: 'wa' },
  { label: 'Welsh', value: 'cy' },
  { label: 'Wolof', value: 'wo' },
  { label: 'Western Frisian', value: 'fy' },
  { label: 'Xhosa', value: 'xh' },
  { label: 'Yiddish', value: 'yi' },
  { label: 'Yoruba', value: 'yo' },
  { label: 'Zhuang', value: 'za' },
  { label: 'Zulu', value: 'zu' }
]

/**
 * Endonyms (each language's name in its own language) for every LANGUAGE_OPTIONS code — e.g.
 * es → "Español", de → "Deutsch", ja → "日本語". Baked from Node's full-ICU
 * `Intl.DisplayNames` at authoring time rather than resolved in the browser, because browser
 * `Intl` endonym coverage is inconsistent (older Safari/engines return English for many codes),
 * which made the profile dropdown show only a couple of languages natively. Keyed by ISO code;
 * consumers fall back to the English LANGUAGE_OPTIONS label for any code missing here.
 *
 * To regenerate: map LANGUAGE_OPTIONS through
 *   new Intl.DisplayNames([code], { type: 'language' }).of(code)
 * (capitalize the first letter) in a full-ICU Node runtime.
 */
export const LANGUAGE_NATIVE_LABELS: Record<string, string> = {
  ab: 'Abkhazian',
  aa: 'Afar',
  af: 'Afrikaans',
  ak: 'Akan',
  sq: 'Shqip',
  am: 'አማርኛ',
  ar: 'العربية',
  an: 'Aragonese',
  hy: 'Հայերեն',
  as: 'অসমীয়া',
  av: 'Avaric',
  ae: 'Avestan',
  ay: 'Aymara',
  az: 'Azərbaycan',
  bm: 'Bamanakan',
  ba: 'Bashkir',
  eu: 'Euskara',
  be: 'Беларуская',
  bn: 'বাংলা',
  bh: 'Bhojpuri',
  bi: 'Bislama',
  bs: 'Bosanski',
  br: 'Brezhoneg',
  bg: 'Български',
  my: 'မြန်မာ',
  ca: 'Català',
  ceb: 'Cebuano',
  ch: 'Chamorro',
  ce: 'Нохчийн',
  ny: 'Nyanja',
  zh: '中文',
  'zh-TW': '中文（台灣）',
  cv: 'Чӑваш',
  kw: 'Kernewek',
  co: 'Corsican',
  cr: 'Cree',
  hr: 'Hrvatski',
  cs: 'Čeština',
  da: 'Dansk',
  dv: 'Divehi',
  nl: 'Nederlands',
  dz: 'རྫོང་ཁ',
  en: 'English',
  eo: 'Esperanto',
  et: 'Eesti',
  ee: 'Eʋegbe',
  fo: 'Føroyskt',
  fj: 'Fijian',
  fi: 'Suomi',
  fr: 'Français',
  ff: 'Pulaar',
  gl: 'Galego',
  ka: 'Ქართული',
  de: 'Deutsch',
  el: 'Ελληνικά',
  gn: 'Guarani',
  gu: 'ગુજરાતી',
  ht: 'Haitian Creole',
  ha: 'Hausa',
  haw: 'ʻŌlelo Hawaiʻi',
  he: 'עברית',
  hz: 'Herero',
  hi: 'हिन्दी',
  ho: 'Hiri Motu',
  hmn: 'Hmong',
  hu: 'Magyar',
  ia: 'Interlingua',
  id: 'Indonesia',
  ie: 'Interlingue',
  ga: 'Gaeilge',
  ig: 'Igbo',
  ik: 'Inupiaq',
  io: 'Ido',
  is: 'Íslenska',
  it: 'Italiano',
  iu: 'Inuktitut',
  ja: '日本語',
  jv: 'Jawa',
  kl: 'Kalaallisut',
  kn: 'ಕನ್ನಡ',
  kr: 'Kanuri',
  ks: 'کٲشُر',
  kk: 'Қазақ тілі',
  km: 'ខ្មែរ',
  ki: 'Gikuyu',
  rw: 'Ikinyarwanda',
  ky: 'Кыргызча',
  kv: 'Komi',
  kg: 'Kongo',
  ko: '한국어',
  ku: 'Kurdî (kurmancî)',
  kj: 'Kuanyama',
  lo: 'ລາວ',
  la: 'Latin',
  lv: 'Latviešu',
  li: 'Limburgish',
  ln: 'Lingála',
  lt: 'Lietuvių',
  lu: 'Tshiluba',
  lb: 'Lëtzebuergesch',
  mk: 'Македонски',
  mg: 'Malagasy',
  ms: 'Melayu',
  ml: 'മലയാളം',
  mt: 'Malti',
  gv: 'Gaelg',
  mi: 'Māori',
  mr: 'मराठी',
  mh: 'Marshallese',
  mn: 'Монгол',
  na: 'Nauru',
  nv: 'Navajo',
  nb: 'Norsk bokmål',
  nd: 'IsiNdebele',
  ne: 'नेपाली',
  ng: 'Ndonga',
  nn: 'Norsk nynorsk',
  no: 'Norsk',
  ii: 'ꆈꌠꉙ',
  nr: 'South Ndebele',
  oc: 'Occitan',
  oj: 'Ojibwa',
  cu: 'Church Slavic',
  om: 'Oromoo',
  or: 'ଓଡ଼ିଆ',
  os: 'Ирон',
  pa: 'ਪੰਜਾਬੀ',
  pi: 'Pali',
  ps: 'پښتو',
  fa: 'فارسی',
  pl: 'Polski',
  pt: 'Português',
  qu: 'Runasimi',
  rm: 'Rumantsch',
  rn: 'Ikirundi',
  ro: 'Română',
  ru: 'Русский',
  sa: 'संस्कृत भाषा',
  sc: 'Sardu',
  sd: 'سنڌي',
  se: 'Davvisámegiella',
  sm: 'Samoan',
  sg: 'Sängö',
  sr: 'Српски',
  gd: 'Gàidhlig',
  sn: 'ChiShona',
  si: 'සිංහල',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  so: 'Soomaali',
  st: 'Sesotho',
  es: 'Español',
  su: 'Basa Sunda',
  sw: 'Kiswahili',
  ss: 'Swati',
  sv: 'Svenska',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  tg: 'Тоҷикӣ',
  th: 'ไทย',
  ti: 'ትግርኛ',
  bo: 'བོད་སྐད་',
  tk: 'Türkmen dili',
  tl: 'Filipino',
  tn: 'Setswana',
  to: 'Lea fakatonga',
  tr: 'Türkçe',
  ts: 'Tsonga',
  tt: 'Татар',
  tw: 'Akan',
  ty: 'Tahitian',
  ug: 'ئۇيغۇرچە',
  uk: 'Українська',
  ur: 'اردو',
  uz: 'O‘zbek',
  ve: 'Venda',
  vi: 'Tiếng Việt',
  vo: 'Volapük',
  wa: 'Walloon',
  cy: 'Cymraeg',
  wo: 'Wolof',
  fy: 'Frysk',
  xh: 'IsiXhosa',
  yi: 'ייִדיש',
  yo: 'Èdè Yorùbá',
  za: 'Vahcuengh',
  zu: 'IsiZulu'
}

/**
 * Language names localized into each supported UI language (exonyms) — so a painter viewing
 * the app in Spanish sees 'Alemán' for German, and in French 'Allemand'. Baked from Node
 * full-ICU Intl.DisplayNames (browser endonym/exonym coverage is inconsistent across engines).
 * English UI intentionally uses LANGUAGE_NATIVE_LABELS (endonyms) instead, so this map only
 * carries the non-English supported UI langs. Consumers pick the map by active UI lang and fall
 * back to endonyms, then the English LANGUAGE_OPTIONS label.
 */
export const LANGUAGE_LABELS_BY_LANG: Record<string, Record<string, string>> = {
  es: {
    ab: 'Abjasio',
    aa: 'Afar',
    af: 'Afrikáans',
    ak: 'Akan',
    sq: 'Albanés',
    am: 'Amárico',
    ar: 'Árabe',
    an: 'Aragonés',
    hy: 'Armenio',
    as: 'Asamés',
    av: 'Avar',
    ae: 'Avéstico',
    ay: 'Aimara',
    az: 'Azerbaiyano',
    bm: 'Bambara',
    ba: 'Baskir',
    eu: 'Euskera',
    be: 'Bielorruso',
    bn: 'Bengalí',
    bh: 'Bhoyapurí',
    bi: 'Bislama',
    bs: 'Bosnio',
    br: 'Bretón',
    bg: 'Búlgaro',
    my: 'Birmano',
    ca: 'Catalán',
    ceb: 'Cebuano',
    ch: 'Chamorro',
    ce: 'Checheno',
    ny: 'Nyanja',
    zh: 'Chino',
    'zh-TW': 'Chino (Taiwán)',
    cv: 'Chuvasio',
    kw: 'Córnico',
    co: 'Corso',
    cr: 'Cree',
    hr: 'Croata',
    cs: 'Checo',
    da: 'Danés',
    dv: 'Divehi',
    nl: 'Neerlandés',
    dz: 'Dzongkha',
    en: 'Inglés',
    eo: 'Esperanto',
    et: 'Estonio',
    ee: 'Ewé',
    fo: 'Feroés',
    fj: 'Fiyiano',
    fi: 'Finés',
    fr: 'Francés',
    ff: 'Fula',
    gl: 'Gallego',
    ka: 'Georgiano',
    de: 'Alemán',
    el: 'Griego',
    gn: 'Guaraní',
    gu: 'Guyaratí',
    ht: 'Criollo haitiano',
    ha: 'Hausa',
    haw: 'Hawaiano',
    he: 'Hebreo',
    hz: 'Herero',
    hi: 'Hindi',
    ho: 'Hiri motu',
    hmn: 'Hmong',
    hu: 'Húngaro',
    ia: 'Interlingua',
    id: 'Indonesio',
    ie: 'Interlingue',
    ga: 'Irlandés',
    ig: 'Igbo',
    ik: 'Inupiaq',
    io: 'Ido',
    is: 'Islandés',
    it: 'Italiano',
    iu: 'Inuktitut',
    ja: 'Japonés',
    jv: 'Javanés',
    kl: 'Groenlandés',
    kn: 'Canarés',
    kr: 'Kanuri',
    ks: 'Cachemir',
    kk: 'Kazajo',
    km: 'Jemer',
    ki: 'Kikuyu',
    rw: 'Kinyarwanda',
    ky: 'Kirguís',
    kv: 'Komi',
    kg: 'Kongo',
    ko: 'Coreano',
    ku: 'Kurdo',
    kj: 'Kuanyama',
    lo: 'Lao',
    la: 'Latín',
    lv: 'Letón',
    li: 'Limburgués',
    ln: 'Lingala',
    lt: 'Lituano',
    lu: 'Luba-katanga',
    lb: 'Luxemburgués',
    mk: 'Macedonio',
    mg: 'Malgache',
    ms: 'Malayo',
    ml: 'Malayálam',
    mt: 'Maltés',
    gv: 'Manés',
    mi: 'Maorí',
    mr: 'Maratí',
    mh: 'Marshalés',
    mn: 'Mongol',
    na: 'Nauruano',
    nv: 'Navajo',
    nb: 'Noruego bokmal',
    nd: 'Ndebele septentrional',
    ne: 'Nepalí',
    ng: 'Ndonga',
    nn: 'Noruego nynorsk',
    no: 'Noruego',
    ii: 'Yi de Sichuán',
    nr: 'Ndebele meridional',
    oc: 'Occitano',
    oj: 'Ojibwa',
    cu: 'Eslavo eclesiástico',
    om: 'Oromo',
    or: 'Oriya',
    os: 'Osético',
    pa: 'Punyabí',
    pi: 'Pali',
    ps: 'Pastún',
    fa: 'Persa',
    pl: 'Polaco',
    pt: 'Portugués',
    qu: 'Quechua',
    rm: 'Romanche',
    rn: 'Kirundi',
    ro: 'Rumano',
    ru: 'Ruso',
    sa: 'Sánscrito',
    sc: 'Sardo',
    sd: 'Sindi',
    se: 'Sami septentrional',
    sm: 'Samoano',
    sg: 'Sango',
    sr: 'Serbio',
    gd: 'Gaélico escocés',
    sn: 'Shona',
    si: 'Cingalés',
    sk: 'Eslovaco',
    sl: 'Esloveno',
    so: 'Somalí',
    st: 'Sotho meridional',
    es: 'Español',
    su: 'Sundanés',
    sw: 'Suajili',
    ss: 'Suazi',
    sv: 'Sueco',
    ta: 'Tamil',
    te: 'Telugu',
    tg: 'Tayiko',
    th: 'Tailandés',
    ti: 'Tigriña',
    bo: 'Tibetano',
    tk: 'Turcomano',
    tl: 'Filipino',
    tn: 'Setsuana',
    to: 'Tongano',
    tr: 'Turco',
    ts: 'Tsonga',
    tt: 'Tártaro',
    tw: 'Akan',
    ty: 'Tahitiano',
    ug: 'Uigur',
    uk: 'Ucraniano',
    ur: 'Urdu',
    uz: 'Uzbeko',
    ve: 'Venda',
    vi: 'Vietnamita',
    vo: 'Volapük',
    wa: 'Valón',
    cy: 'Galés',
    wo: 'Wólof',
    fy: 'Frisón occidental',
    xh: 'Xhosa',
    yi: 'Yidis',
    yo: 'Yoruba',
    za: 'Zhuang',
    zu: 'Zulú'
  },
  fr: {
    ab: 'Abkhaze',
    aa: 'Afar',
    af: 'Afrikaans',
    ak: 'Akan',
    sq: 'Albanais',
    am: 'Amharique',
    ar: 'Arabe',
    an: 'Aragonais',
    hy: 'Arménien',
    as: 'Assamais',
    av: 'Avar',
    ae: 'Avestique',
    ay: 'Aymara',
    az: 'Azerbaïdjanais',
    bm: 'Bambara',
    ba: 'Bachkir',
    eu: 'Basque',
    be: 'Biélorusse',
    bn: 'Bengali',
    bh: 'Bhodjpouri',
    bi: 'Bichelamar',
    bs: 'Bosniaque',
    br: 'Breton',
    bg: 'Bulgare',
    my: 'Birman',
    ca: 'Catalan',
    ceb: 'Cebuano',
    ch: 'Chamorro',
    ce: 'Tchétchène',
    ny: 'Chewa',
    zh: 'Chinois',
    'zh-TW': 'Chinois (Taïwan)',
    cv: 'Tchouvache',
    kw: 'Cornique',
    co: 'Corse',
    cr: 'Cree',
    hr: 'Croate',
    cs: 'Tchèque',
    da: 'Danois',
    dv: 'Maldivien',
    nl: 'Néerlandais',
    dz: 'Dzongkha',
    en: 'Anglais',
    eo: 'Espéranto',
    et: 'Estonien',
    ee: 'Éwé',
    fo: 'Féroïen',
    fj: 'Fidjien',
    fi: 'Finnois',
    fr: 'Français',
    ff: 'Peul',
    gl: 'Galicien',
    ka: 'Géorgien',
    de: 'Allemand',
    el: 'Grec',
    gn: 'Guarani',
    gu: 'Goudjarati',
    ht: 'Créole haïtien',
    ha: 'Haoussa',
    haw: 'Hawaïen',
    he: 'Hébreu',
    hz: 'Héréro',
    hi: 'Hindi',
    ho: 'Hiri motu',
    hmn: 'Hmong',
    hu: 'Hongrois',
    ia: 'Interlingua',
    id: 'Indonésien',
    ie: 'Interlingue',
    ga: 'Irlandais',
    ig: 'Igbo',
    ik: 'Inupiaq',
    io: 'Ido',
    is: 'Islandais',
    it: 'Italien',
    iu: 'Inuktitut',
    ja: 'Japonais',
    jv: 'Javanais',
    kl: 'Groenlandais',
    kn: 'Kannada',
    kr: 'Kanouri',
    ks: 'Cachemiri',
    kk: 'Kazakh',
    km: 'Khmer',
    ki: 'Kikuyu',
    rw: 'Kinyarwanda',
    ky: 'Kirghize',
    kv: 'Komi',
    kg: 'Kikongo',
    ko: 'Coréen',
    ku: 'Kurde',
    kj: 'Kuanyama',
    lo: 'Lao',
    la: 'Latin',
    lv: 'Letton',
    li: 'Limbourgeois',
    ln: 'Lingala',
    lt: 'Lituanien',
    lu: 'Luba-katanga (kiluba)',
    lb: 'Luxembourgeois',
    mk: 'Macédonien',
    mg: 'Malgache',
    ms: 'Malais',
    ml: 'Malayalam',
    mt: 'Maltais',
    gv: 'Mannois',
    mi: 'Maori',
    mr: 'Marathi',
    mh: 'Marshallais',
    mn: 'Mongol',
    na: 'Nauruan',
    nv: 'Navajo',
    nb: 'Norvégien bokmål',
    nd: 'Ndébélé du Nord',
    ne: 'Népalais',
    ng: 'Ndonga',
    nn: 'Norvégien nynorsk',
    no: 'Norvégien',
    ii: 'Yi du Sichuan',
    nr: 'Ndébélé du Sud',
    oc: 'Occitan',
    oj: 'Ojibwa',
    cu: 'Slavon d’église',
    om: 'Oromo',
    or: 'Odia',
    os: 'Ossète',
    pa: 'Pendjabi',
    pi: 'Pali',
    ps: 'Pachto',
    fa: 'Persan',
    pl: 'Polonais',
    pt: 'Portugais',
    qu: 'Quechua',
    rm: 'Romanche',
    rn: 'Roundi',
    ro: 'Roumain',
    ru: 'Russe',
    sa: 'Sanskrit',
    sc: 'Sarde',
    sd: 'Sindhi',
    se: 'Same du Nord',
    sm: 'Samoan',
    sg: 'Sango',
    sr: 'Serbe',
    gd: 'Gaélique écossais',
    sn: 'Shona',
    si: 'Cingalais',
    sk: 'Slovaque',
    sl: 'Slovène',
    so: 'Somali',
    st: 'Sotho du Sud',
    es: 'Espagnol',
    su: 'Soundanais',
    sw: 'Swahili',
    ss: 'Swati',
    sv: 'Suédois',
    ta: 'Tamoul',
    te: 'Télougou',
    tg: 'Tadjik',
    th: 'Thaï',
    ti: 'Tigrigna',
    bo: 'Tibétain',
    tk: 'Turkmène',
    tl: 'Filipino',
    tn: 'Tswana',
    to: 'Tongien',
    tr: 'Turc',
    ts: 'Tsonga',
    tt: 'Tatar',
    tw: 'Akan',
    ty: 'Tahitien',
    ug: 'Ouïghour',
    uk: 'Ukrainien',
    ur: 'Ourdou',
    uz: 'Ouzbek',
    ve: 'Venda',
    vi: 'Vietnamien',
    vo: 'Volapük',
    wa: 'Wallon',
    cy: 'Gallois',
    wo: 'Wolof',
    fy: 'Frison occidental',
    xh: 'Xhosa',
    yi: 'Yiddish',
    yo: 'Yoruba',
    za: 'Zhuang',
    zu: 'Zoulou'
  }
}
